import { IAppState } from '../../redux';
import { selectIsMasterMoneySource } from './selectIsMasterMoneySource';

export const selectBalance = (state: IAppState): number => {
  const {
    user: { balance, limitedBalance, agencyBalance },
  } = state;

  const isMasterMoneySource = selectIsMasterMoneySource(state);

  return isMasterMoneySource ? limitedBalance || agencyBalance : balance;
};
